/* eslint-disable react/no-danger */
import Script from 'next/script'
import React from 'react'

export const scriptContent = `
  if (!window.debug) {
    window.debug = function (){}
  }
  (function () {
    var sleeknoteScriptTag = document.createElement('script');
    sleeknoteScriptTag.type = 'text/javascript';
    sleeknoteScriptTag.charset = 'utf-8';
    sleeknoteScriptTag.src = ('//sleeknotecustomerscripts.sleeknote.com/22489.js');
    var s = document.getElementById('sleeknoteScript');
    s.parentNode.insertBefore(sleeknoteScriptTag, s);
  })();

`

export const SleekButtonScript = () => (
  <Script
    key="sleeknoteScript"
    dangerouslySetInnerHTML={{ __html: scriptContent }}
    id="sleeknoteScript"
    type="text/javascript"
  />
)
